"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blankValues_1 = require("./blankValues");
Object.defineProperty(exports, "blankValues", { enumerable: true, get: function () { return blankValues_1.blankValues; } });
var supportsTime_1 = require("./supportsTime");
Object.defineProperty(exports, "supportsTime", { enumerable: true, get: function () { return supportsTime_1.default; } });
